export const MEETING_TYPES = [
  { value: "city-council", label: "City Council" },
  { value: "planning-zoning", label: "Planning & Zoning" },
  { value: "board-adjustment", label: "Board of Adjustment" },
  {
    value: "historic-preservation-committee",
    label: "Historic Preservation Committee",
  },
] as const;

export const MEETING_SUBTYPES = [
  { value: "regular", label: "Regular Meeting" },
  { value: "special-meeting", label: "Special Meeting" },
  { value: "public-hearing", label: "Public Hearing" },
  { value: "public-notice", label: "Public Notice" },
] as const;

export const MEETING_STATUS = [
  { value: "scheduled", label: "Scheduled" },
  { value: "completed", label: "Completed" },
  { value: "cancelled", label: "Cancelled" },
] as const;

export type MeetingType = (typeof MEETING_TYPES)[number]["value"];
export type MeetingSubtype = (typeof MEETING_SUBTYPES)[number]["value"];
export type MeetingStatus = (typeof MEETING_STATUS)[number]["value"];
